module.exports = __webpack_public_path__ + "static/media/man-work.590a2c1d.png";